import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { LOGO, NavBar, FB_URL, IG_URL, WHATSAPP, RECEPTION_WHATSAPP, BANK, ADDRESS } from "../shared";


const ITEMS = [
  { id: "shirts", label: "Shirts / Blouses", icon: "👔" },
  { id: "trousers", label: "Trousers / Jeans", icon: "👖" },
  { id: "dresses", label: "Dresses / Gowns", icon: "👗" },
  { id: "suits", label: "Suits / Jackets", icon: "🧥" },
  { id: "underwear", label: "Underwear / Socks", icon: "🩲" },
  { id: "bedding", label: "Bedsheets / Pillowcases", icon: "🛏️" },
  { id: "towels", label: "Towels", icon: "🧸" },
  { id: "traditional", label: "Traditional Attire", icon: "👘" },
  { id: "other", label: "Other Items", icon: "🧺" },
];

function buildMsg({ ref, customerType, form, items }) {
  const itemLines = Object.entries(items)
    .filter(([, qty]) => qty > 0)
    .map(([id, qty]) => {
      const item = ITEMS.find(i => i.id === id);
      return "  • " + item.label + " x" + qty;
    }).join("\n");

  const typeLabel = customerType === "guest" ? "IN-HOUSE GUEST" : "OUTSIDE CUSTOMER";
  const pickupLine = customerType === "outside"
    ? "\n  Pickup Address: " + (form.address || "TBC") + "\n  (Pickup surcharge applies)"
    : "\n  Room: " + (form.room || "TBC") + " — or drop at reception";

  return `🧺 *NEW LAUNDRY REQUEST — THE 401 HOTEL & SUITES LTD*
━━━━━━━━━━━━━━━━━━
🔖 Ref: *${ref}*
📅 ${new Date().toLocaleDateString("en-NG", { weekday: "short", day: "numeric", month: "long", year: "numeric" })}
👤 Type: *${typeLabel}*
━━━━━━━━━━━━━━━━━━
👤 *CUSTOMER:*
  Name: ${form.name}
  Phone: ${form.phone}${pickupLine}
━━━━━━━━━━━━━━━━━━
🧺 *ITEMS:*
${itemLines || "  (Items to be confirmed on collection)"}
━━━━━━━━━━━━━━━━━━
📋 *SERVICE TYPE:* ${form.service || "Standard Wash"}
⏰ *Preferred Ready By:* ${form.readyBy || "As soon as possible"}
📝 *Special Notes:* ${form.notes || "None"}
━━━━━━━━━━━━━━━━━━
Please confirm pricing and collection time.
Reply CONFIRMED once agreed.`;
}

export default function Laundry() {
  const navigate = useNavigate();
  const [page, setPage] = useState("home");
  const [customerType, setCustomerType] = useState(null);
  const [items, setItems] = useState({});
  const [form, setForm] = useState({ name: "", phone: "", room: "", address: "", service: "", readyBy: "", notes: "" });
  const [sending, setSending] = useState(false);
  const [ref] = useState(() => "401L-" + Math.floor(1000 + Math.random() * 9000));

  const totalItems = Object.values(items).reduce((a, v) => a + v, 0);

  const updateItem = (id, delta) => {
    setItems(prev => {
      const cur = prev[id] || 0;
      const next = Math.max(0, cur + delta);
      if (next === 0) { const c = { ...prev }; delete c[id]; return c; }
      return { ...prev, [id]: next };
    });
  };

  const send = () => {
    setSending(true);
    const msg = buildMsg({ ref, customerType, form, items });
    setTimeout(() => {
      window.open("https://wa.me/" + WHATSAPP + "?text=" + encodeURIComponent(msg), "_blank");
      setSending(false);
      setPage("confirm");
    }, 800);
  };

  const C = {
    bg: "#060a0e", surface: "#0a1018", card: "#111a24", border: "#1a2838",
    gold: "#c8a040", goldLight: "#e8c060", goldDim: "#7a6020",
    cream: "#eadfc8", muted: "#607080", green: "#3aad72", teal: "#2aab8a",
  };

  const inp = { width: "100%", background: C.card, border: `1px solid ${C.border}`, borderRadius: 10, padding: "12px 14px", color: C.cream, fontSize: 14, fontFamily: "inherit", marginBottom: 14, boxSizing: "border-box", outline: "none", colorScheme: "dark" };
  const lbl = { display: "block", fontSize: 10, letterSpacing: 2, color: C.gold, marginBottom: 6 };
  const goldBtn = { display: "block", width: "100%", background: `linear-gradient(135deg,${C.gold},${C.goldLight})`, border: "none", borderRadius: 12, padding: "15px", fontSize: 15, fontWeight: "bold", color: "#06080a", cursor: "pointer", letterSpacing: 1, fontFamily: "inherit", marginTop: 16 };

  // ── HOME ─────────────────────────────────────────────────────────────────
  const renderHome = () => (
    <div>
      <div style={{ background: "linear-gradient(160deg,#0a1820 0%,#060a0e 100%)", padding: "40px 22px 32px", textAlign: "center", borderBottom: `1px solid ${C.border}` }}>
        <div style={{ display: "inline-block", border: `1px solid ${C.goldDim}`, color: C.gold, padding: "3px 16px", borderRadius: 20, fontSize: 10, letterSpacing: 3, marginBottom: 18 }}>THE 401 HOTEL & SUITES LTD</div>
        <div style={{ fontSize: 56, marginBottom: 14 }}>🧺</div>
        <h1 style={{ fontSize: 30, fontWeight: "bold", color: C.cream, margin: "0 0 8px", lineHeight: 1.1 }}>401 Laundry<br />Service</h1>
        <p style={{ color: C.gold, fontSize: 13, margin: "0 0 6px", fontStyle: "italic" }}>Quiet. Private. Professional. Serenity.</p>
        <p style={{ color: C.muted, fontSize: 12, margin: "0 0 28px", letterSpacing: 1, lineHeight: 1.7 }}>
          Fresh, clean & ready — for hotel guests and outside customers alike.<br />
          <span style={{ color: C.teal }}>We offer pickup for outside customers.</span>
        </p>

        {/* Pricing note */}
        <div style={{ background: `${C.gold}12`, border: `1px solid ${C.gold}33`, borderRadius: 14, padding: "14px 18px", marginBottom: 24 }}>
          <div style={{ fontSize: 11, color: C.gold, letterSpacing: 2, marginBottom: 6 }}>PRICING</div>
          <div style={{ color: C.cream, fontSize: 13, lineHeight: 1.7 }}>
            Prices are quoted per item based on current rates.<br />
            <span style={{ color: C.gold, fontWeight: "bold" }}>Outside pickup attracts an additional delivery charge.</span>
          </div>
          <a href={"https://wa.me/" + WHATSAPP + "?text=Hello! Please send me the current laundry rates at The 401 Hotel."}
            target="_blank" rel="noreferrer"
            style={{ display: "inline-block", marginTop: 10, background: "#25D366", borderRadius: 8, padding: "7px 16px", color: "#fff", fontSize: 12, fontWeight: "bold", textDecoration: "none", fontFamily: "inherit" }}>
            📲 Ask for Today's Rates
          </a>
        </div>

        {/* Customer type */}
        <div style={{ fontSize: 10, letterSpacing: 3, color: C.gold, marginBottom: 14 }}>I AM A...</div>
        <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
          {[
            { type: "guest", icon: "🛎️", title: "Hotel Guest", desc: "Drop at reception or we collect from your room" },
            { type: "outside", icon: "🏠", title: "Outside Customer", desc: "We pick up from your location — extra charge applies" },
          ].map(({ type, icon, title, desc }) => (
            <button key={type} onClick={() => setCustomerType(type)}
              style={{ background: customerType === type ? `${C.teal}18` : C.card, border: `2px solid ${customerType === type ? C.teal : C.border}`, borderRadius: 14, padding: "16px 18px", color: C.cream, cursor: "pointer", display: "flex", alignItems: "center", gap: 14, textAlign: "left", fontFamily: "inherit" }}>
              <span style={{ fontSize: 28 }}>{icon}</span>
              <span style={{ flex: 1 }}>
                <span style={{ display: "block", fontWeight: "bold", fontSize: 15, color: customerType === type ? C.teal : C.cream }}>{title}</span>
                <span style={{ display: "block", fontSize: 12, color: C.muted, marginTop: 3 }}>{desc}</span>
              </span>
              {customerType === type && <span style={{ color: C.teal, fontSize: 18 }}>✓</span>}
            </button>
          ))}
        </div>
        {customerType && <button style={goldBtn} onClick={() => setPage("items")}>Select Items →</button>}
      </div>

      {/* How it works */}
      <div style={{ padding: "22px 18px" }}>
        <div style={{ fontSize: 10, letterSpacing: 3, color: C.gold, marginBottom: 16 }}>HOW IT WORKS</div>
        {(customerType === "outside" ? [
          ["📲", "Submit your laundry request below"],
          ["🚗", "Our team picks up from your location"],
          ["🧼", "We wash, dry & fold your clothes"],
          ["🚗", "We deliver back to you — or you collect"],
          ["💬", "Pricing confirmed via WhatsApp first"],
        ] : [
          ["📲", "Submit your laundry request below"],
          ["🛎️", "Drop items at reception or call for room collection"],
          ["🧼", "We wash, dry & fold your clothes"],
          ["📦", "Items returned to your room or reception"],
          ["💬", "Pricing confirmed via WhatsApp first"],
        ]).map(([icon, step]) => (
          <div key={step} style={{ display: "flex", gap: 10, marginBottom: 12, alignItems: "flex-start" }}>
            <span style={{ fontSize: 18, flexShrink: 0 }}>{icon}</span>
            <span style={{ fontSize: 12, color: C.muted, lineHeight: 1.6 }}>{step}</span>
          </div>
        ))}
      </div>

      {/* Social footer */}
      <div style={{ padding: "16px 20px 28px", borderTop: `1px solid ${C.border}`, textAlign: "center" }}>
        <div style={{ display: "flex", justifyContent: "center", gap: 16, marginBottom: 12 }}>
          <a href="https://instagram.com/the401hotel" target="_blank" rel="noreferrer" style={{ display: "flex", alignItems: "center", gap: 6, color: C.gold, fontSize: 12, textDecoration: "none", fontFamily: "inherit" }}>📸 @the401hotel</a>
          <a href="https://www.facebook.com/share/1EJKkvzsNL/" target="_blank" rel="noreferrer" style={{ display: "flex", alignItems: "center", gap: 6, color: C.gold, fontSize: 12, textDecoration: "none", fontFamily: "inherit" }}>📘 The 401 Hotel</a>
        </div>
        <p style={{ color: C.muted, fontSize: 10, letterSpacing: 1, lineHeight: 1.8, margin: 0 }}>
          Plot A/39 Iyiagu Estate, Off Abakaliki Street<br />Awka, Anambra State · the401homes.com
        </p>
      </div>
    </div>
  );

  // ── ITEMS ────────────────────────────────────────────────────────────────
  const renderItems = () => (
    <div style={{ padding: "20px 18px" }}>
      <div style={{ fontSize: 10, letterSpacing: 3, color: C.gold, marginBottom: 6 }}>SELECT YOUR ITEMS</div>
      <div style={{ fontSize: 12, color: C.muted, marginBottom: 20 }}>Tap + to add each item type. Leave at 0 if not needed.</div>
      <div style={{ display: "flex", flexDirection: "column", gap: 2 }}>
        {ITEMS.map((item) => {
          const qty = items[item.id] || 0;
          return (
            <div key={item.id} style={{ display: "flex", alignItems: "center", gap: 12, padding: "13px 0", borderBottom: `1px solid ${C.border}33` }}>
              <span style={{ fontSize: 24, width: 36, textAlign: "center", flexShrink: 0 }}>{item.icon}</span>
              <span style={{ flex: 1, fontSize: 14, color: qty > 0 ? C.cream : C.muted }}>{item.label}</span>
              <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <button onClick={() => updateItem(item.id, -1)} disabled={qty === 0}
                  style={{ width: 30, height: 30, borderRadius: 8, border: `1px solid ${C.border}`, background: C.card, color: qty > 0 ? C.gold : C.muted, fontSize: 18, cursor: qty > 0 ? "pointer" : "default", display: "flex", alignItems: "center", justifyContent: "center" }}>−</button>
                <span style={{ fontWeight: "bold", fontSize: 15, minWidth: 22, textAlign: "center", color: qty > 0 ? C.cream : C.muted }}>{qty}</span>
                <button onClick={() => updateItem(item.id, 1)}
                  style={{ width: 30, height: 30, borderRadius: 8, border: "none", background: C.teal, color: "#fff", fontSize: 18, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" }}>+</button>
              </div>
            </div>
          );
        })}
      </div>

      {/* Summary */}
      {totalItems > 0 && (
        <div style={{ background: `${C.teal}15`, border: `1px solid ${C.teal}33`, borderRadius: 12, padding: "12px 16px", margin: "16px 0 0" }}>
          <div style={{ fontSize: 12, color: C.teal, fontWeight: "bold" }}>
            {totalItems} item{totalItems > 1 ? "s" : ""} selected — pricing will be confirmed via WhatsApp
          </div>
        </div>
      )}

      <button style={{ ...goldBtn, background: `linear-gradient(135deg,${C.teal},#35c87a)`, color: "#06080a" }}
        onClick={() => setPage("details")}>
        Continue → Add Your Details
      </button>
      <button onClick={() => setPage("home")} style={{ display: "block", width: "100%", marginTop: 10, background: "transparent", border: `1px solid ${C.border}`, borderRadius: 10, padding: 12, color: C.muted, cursor: "pointer", fontFamily: "inherit", fontSize: 13, boxSizing: "border-box" }}>
        ← Back
      </button>
    </div>
  );

  // ── DETAILS ──────────────────────────────────────────────────────────────
  const renderDetails = () => (
    <div style={{ padding: "20px 18px" }}>
      <div style={{ fontSize: 10, letterSpacing: 3, color: C.gold, marginBottom: 20 }}>YOUR DETAILS</div>

      <label style={lbl}>FULL NAME</label>
      <input style={inp} placeholder="Your name" value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} />

      <label style={lbl}>PHONE NUMBER</label>
      <input style={inp} placeholder="08XXXXXXXXX" value={form.phone} onChange={e => setForm({ ...form, phone: e.target.value })} />

      {customerType === "guest" && (
        <>
          <label style={lbl}>ROOM NUMBER</label>
          <input style={inp} placeholder="e.g. 204 (or leave blank to drop at reception)" value={form.room} onChange={e => setForm({ ...form, room: e.target.value })} />
        </>
      )}

      {customerType === "outside" && (
        <>
          <label style={lbl}>PICKUP ADDRESS</label>
          <input style={inp} placeholder="Street, area, nearest landmark..." value={form.address} onChange={e => setForm({ ...form, address: e.target.value })} />
          <div style={{ background: `${C.teal}12`, border: `1px solid ${C.teal}33`, borderRadius: 10, padding: "10px 14px", marginBottom: 14, fontSize: 12, color: C.muted }}>
            ⚡ Pickup from outside the hotel attracts an additional charge. This will be confirmed via WhatsApp before collection.
          </div>
        </>
      )}

      <label style={lbl}>SERVICE TYPE</label>
      <div style={{ display: "flex", flexWrap: "wrap", gap: 8, marginBottom: 14 }}>
        {["Wash & Fold", "Wash & Iron", "Dry Cleaning", "Iron Only"].map(opt => (
          <button key={opt} onClick={() => setForm({ ...form, service: opt })}
            style={{ background: form.service === opt ? C.teal : C.card, border: `1px solid ${form.service === opt ? C.teal : C.border}`, borderRadius: 8, padding: "9px 14px", color: form.service === opt ? "#fff" : C.muted, fontSize: 12, cursor: "pointer", fontFamily: "inherit", fontWeight: form.service === opt ? "bold" : "normal" }}>
            {opt}
          </button>
        ))}
      </div>

      <label style={lbl}>PREFERRED READY BY</label>
      <div style={{ display: "flex", flexWrap: "wrap", gap: 8, marginBottom: 14 }}>
        {["Same Day", "Next Day", "2 Days", "No Rush"].map(opt => (
          <button key={opt} onClick={() => setForm({ ...form, readyBy: opt })}
            style={{ background: form.readyBy === opt ? C.gold : C.card, border: `1px solid ${form.readyBy === opt ? C.gold : C.border}`, borderRadius: 8, padding: "9px 14px", color: form.readyBy === opt ? "#06080a" : C.muted, fontSize: 12, cursor: "pointer", fontFamily: "inherit", fontWeight: form.readyBy === opt ? "bold" : "normal" }}>
            {opt}
          </button>
        ))}
      </div>

      <label style={lbl}>SPECIAL NOTES (OPTIONAL)</label>
      <textarea style={{ ...inp, minHeight: 72, resize: "vertical" }} placeholder="Delicate items, stain treatment, handle with care..." value={form.notes} onChange={e => setForm({ ...form, notes: e.target.value })} />

      {/* Summary */}
      <div style={{ background: C.card, border: `1px solid ${C.border}`, borderRadius: 14, padding: "16px 18px", marginBottom: 4 }}>
        <div style={{ fontSize: 10, letterSpacing: 3, color: C.gold, marginBottom: 12 }}>YOUR REQUEST SUMMARY</div>
        <div style={{ fontSize: 13, color: C.muted, marginBottom: 8 }}>
          <span style={{ color: customerType === "guest" ? C.teal : C.gold }}>
            {customerType === "guest" ? "🛎️ In-House Guest" : "🏠 Outside Customer (Pickup)"}
          </span>
        </div>
        {totalItems > 0 && (
          <div style={{ fontSize: 12, color: C.muted, marginBottom: 8 }}>
            {Object.entries(items).filter(([, q]) => q > 0).map(([id, qty]) => {
              const item = ITEMS.find(i => i.id === id);
              return <div key={id} style={{ marginBottom: 4 }}>{item.icon} {item.label} ×{qty}</div>;
            })}
          </div>
        )}
        <div style={{ fontSize: 11, color: C.muted, marginTop: 8, lineHeight: 1.7 }}>
          Pricing will be confirmed on WhatsApp before we proceed.
        </div>
      </div>

      <button onClick={() => {
        if (!form.name || !form.phone) return alert("Please enter your name and phone number.");
        if (customerType === "outside" && !form.address) return alert("Please enter your pickup address.");
        send();
      }}
        style={{ display: "block", width: "100%", background: sending ? "#1a8a40" : "#25D366", border: "none", borderRadius: 12, padding: "16px", fontSize: 15, fontWeight: "bold", color: "#fff", cursor: "pointer", letterSpacing: 0.5, fontFamily: "inherit", marginTop: 16 }}>
        {sending ? "⏳ Opening WhatsApp..." : "📲 Send Laundry Request via WhatsApp"}
      </button>
      <p style={{ textAlign: "center", fontSize: 10, color: C.muted, marginTop: 10, letterSpacing: 1 }}>
        Your request goes directly to our laundry team on WhatsApp
      </p>
    </div>
  );

  // ── CONFIRM ──────────────────────────────────────────────────────────────
  const renderConfirm = () => (
    <div style={{ padding: 32, textAlign: "center" }}>
      <div style={{ fontSize: 64, marginBottom: 12 }}>🧺</div>
      <div style={{ fontSize: 28, fontWeight: "bold", color: C.teal, marginBottom: 8 }}>Request Sent!</div>
      <div style={{ fontSize: 11, color: C.muted, letterSpacing: 3, marginBottom: 12 }}>LAUNDRY REF</div>
      <div style={{ background: C.card, border: `1px solid ${C.teal}44`, borderRadius: 14, padding: "14px 28px", fontSize: 22, fontWeight: "bold", color: C.teal, letterSpacing: 4, display: "inline-block", marginBottom: 20 }}>{ref}</div>
      <div style={{ background: "#25D36618", border: "1px solid #25D36644", borderRadius: 14, padding: "16px 18px", marginBottom: 20 }}>
        <div style={{ fontSize: 22, marginBottom: 6 }}>📲</div>
        <div style={{ color: "#25D366", fontWeight: "bold", fontSize: 14, marginBottom: 6 }}>Request sent to our laundry team</div>
        <div style={{ color: C.muted, fontSize: 12, lineHeight: 1.7 }}>
          We will confirm pricing via WhatsApp before proceeding.
          {customerType === "outside" && " Our team will contact you to arrange pickup."}
        </div>
      </div>
      <div style={{ background: C.card, border: `1px solid ${C.border}`, borderRadius: 14, padding: 18, textAlign: "left", marginBottom: 20 }}>
        <div style={{ fontSize: 10, letterSpacing: 3, color: C.gold, marginBottom: 12 }}>WHAT HAPPENS NEXT</div>
        {(customerType === "outside" ? [
          ["1️⃣", "We confirm pricing on WhatsApp"],
          ["2️⃣", "Our team arranges pickup from your location"],
          ["3️⃣", "We wash, dry & fold your items"],
          ["4️⃣", "We deliver back or you collect from the hotel"],
        ] : [
          ["1️⃣", "We confirm pricing on WhatsApp"],
          ["2️⃣", "Drop items at reception or call for room collection"],
          ["3️⃣", "We wash, dry & fold your items"],
          ["4️⃣", "Items returned to your room or reception"],
        ]).map(([num, step]) => (
          <div key={num} style={{ display: "flex", gap: 10, marginBottom: 10, fontSize: 13 }}>
            <span>{num}</span>
            <span style={{ color: C.muted }}>{step}</span>
          </div>
        ))}
      </div>
      <button onClick={() => { setPage("home"); setItems({}); setCustomerType(null); setForm({ name: "", phone: "", room: "", address: "", service: "", readyBy: "", notes: "" }); }}
        style={{ background: "transparent", border: `1px solid ${C.border}`, borderRadius: 10, padding: "12px 24px", color: C.muted, cursor: "pointer", fontFamily: "inherit", fontSize: 13 }}>
        ← New Request
      </button>
    </div>
  );

  return (
    <div style={{ fontFamily: "\'Palatino Linotype\',\'Book Antiqua\',Palatino,Georgia,serif", background: C.bg, minHeight: "100vh", color: C.cream, maxWidth: "100%", margin: "0 auto" }}>
      <NavBar title="Laundry Service" />
      <style>{`@media(min-width:768px){.pb{max-width:720px;margin:0 auto}.cr{display:grid!important;grid-template-columns:repeat(auto-fill,minmax(170px,1fr))!important}}`}</style>
      {/* Header */}
      <div style={{ background: C.surface, borderBottom: `1px solid ${C.border}`, padding: "14px 18px", display: "flex", alignItems: "center", justifyContent: "space-between", position: "sticky", top: 0, zIndex: 100 }}>
        <div>
          <img src={LOGO} style={{ height: 36, objectFit: "contain", display: "block", marginBottom: 2 }} alt="The 401 Hotel & Suites Ltd" />
          <div style={{ fontSize: 10, color: C.muted, letterSpacing: 1 }}>LAUNDRY SERVICE</div>
        </div>
        {page !== "home" && page !== "confirm" && (
          <button onClick={() => setPage(page === "details" ? "items" : "home")}
            style={{ background: "transparent", border: `1px solid ${C.border}`, borderRadius: 8, padding: "7px 12px", color: C.muted, cursor: "pointer", fontSize: 12, fontFamily: "inherit" }}>← Back</button>
        )}
      </div>

      {/* Progress */}
      {["items", "details", "confirm"].includes(page) && (
        <div style={{ display: "flex", background: C.surface, borderBottom: `1px solid ${C.border}` }}>
          {[["home", "1. Type"], ["items", "2. Items"], ["details", "3. Details"], ["confirm", "4. Done"]].map(([p, label]) => {
            const steps = ["home", "items", "details", "confirm"];
            const active = steps.indexOf(p) <= steps.indexOf(page);
            return (
              <div key={p} style={{ flex: 1, padding: "8px 4px", textAlign: "center", borderBottom: active ? `2px solid ${C.teal}` : "2px solid transparent" }}>
                <div style={{ fontSize: 9, color: active ? C.teal : C.muted, letterSpacing: 1 }}>{label}</div>
              </div>
            );
          })}
        </div>
      )}

      <div style={{ paddingBottom: 40 }}>
        {page === "home" && renderHome()}
        {page === "items" && renderItems()}
        {page === "details" && renderDetails()}
        {page === "confirm" && renderConfirm()}
      </div>
    </div>
  );
}
